import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, MapPin } from "lucide-react";
import { ctaHref } from "../lib/affiliate";

const FLIGHTS_HREF_CTX = { productType: "flights", provider: "nuitee", position: "header" };

const NAV = [
  { to: "/gameday", label: "GameDay" },
  { to: "/nfl", label: "NFL" },
  { to: "/venues", label: "Venues" },
  { to: "/destinations", label: "Destinations" },
  { to: "/guides", label: "Guides" },
];

export function Logo({ light = false }) {
  return (
    <Link to="/" data-testid="logo-home" className="flex items-center gap-2 shrink-0">
      <span className="grid place-items-center h-8 w-8 rounded-lg bg-primary text-primary-foreground">
        <MapPin className="h-4 w-4" strokeWidth={2.5} />
      </span>
      <span className={`font-heading text-xl font-extrabold tracking-tighter ${light ? "text-white" : "text-ink"}`}>
        Hotelstrips
      </span>
    </Link>
  );
}

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 glass border-b border-black/5">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex h-16 items-center justify-between gap-6">
          <Logo />
          <nav className="hidden md:flex items-center gap-7">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm font-semibold transition-colors hover:text-primary ${isActive ? "text-primary" : "text-ink/80"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={ctaHref(FLIGHTS_HREF_CTX)}
              target="_blank"
              rel="noopener noreferrer sponsored"
              data-testid="nav-flights"
              className="text-sm font-semibold transition-colors hover:text-primary text-ink/80"
            >
              Flights
            </a>
          </nav>
          <div className="flex items-center gap-3">
            <Link
              to="/gameday"
              data-testid="header-cta"
              className="hidden sm:inline-flex items-center rounded-full bg-ink px-5 py-2.5 text-sm font-heading font-semibold text-white transition-transform hover:-translate-y-0.5"
            >
              Plan a trip
            </Link>
            <button
              className="md:hidden p-2 text-ink"
              onClick={() => setOpen((v) => !v)}
              data-testid="mobile-menu-toggle"
              aria-label="Menu"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-black/5 bg-background" data-testid="mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="py-3 text-base font-semibold text-ink border-b border-black/5 last:border-0"
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={ctaHref(FLIGHTS_HREF_CTX)}
              target="_blank"
              rel="noopener noreferrer sponsored"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-flights"
              className="py-3 text-base font-semibold text-ink border-b border-black/5 last:border-0"
            >
              Flights
            </a>
            <Link to="/gameday" onClick={() => setOpen(false)} className="mt-3 inline-flex justify-center rounded-full bg-primary px-5 py-3 text-sm font-heading font-semibold text-primary-foreground">
              Plan a trip
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
